

$('a.customlink').click(function(){
var hrf=$(this).attr('href') ;
      window.location.href=hrf
      })
$('.customHeader details-disclosure>details').mouseenter(function(){
 $(this).attr('open','open');
})
$('.customHeader details-disclosure>details').mouseleave(function(){
 $(this).removeAttr('open');
})

if($('body').hasClass('template-search')){
$(window).scroll(function() {

if ($(window).width() < 767){
        scroll = $(window).scrollTop();

if (scroll >= 300) {


$('.boost-pfs-search-panel-product-show').addClass('fixed');
  
}else{

  $('.boost-pfs-search-panel-product-show').removeClass('fixed');
}



    }
})

}
var swiper = new Swiper(".mySwiper", {
  autoplay: {
    delay: 10000,
  },
   loop: true,
        navigation: {
          nextEl: ".slider__button-next",
          prevEl: ".slider__button-prev",
        },
   pagination: {
      el: '.slider__pagination',
      clickable: true,
    }
      });